import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import {
	CompetenceSSIAD,
	CompetenceSESSAD,
	CompetenceSAAD
} from 'src/app/shared/enums/competence.enum';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { Employee } from 'src/app/shared/models/employee/employee';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';

@Component({
	selector: 'app-modal-content',
	templateUrl: './beneficiaire-modal-detail-formation.component.html',
	styleUrls: ['./beneficiaire-modal-detail-formation.component.scss']
})
export class BeneficiaireModalDetailFormationComponent implements OnInit {
	/**
	 * Beneficiaire, transmit par le service Modal de ngx dans BeneficiaireModalDetailFormationComponent
	 */
	beneficiaire: Beneficiaire;

	/**
	 * MissionRequest, transmit par le service Modal de ngx dans BeneficiaireModalDetailFormationComponent
	 */
	missionRequest: MissionRequest;

	competences;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	uniqueEmployeeOfMission: Employee;

	LABEL_INTERVENTION: string;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService
	) {}

	ngOnInit(): void {
		//this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		//this.isSAAD = this.facade.dataStorageService.isSAAD();
		//this.isSSIAD = this.facade.dataStorageService.isSSIAD();
		this.competences = this.isSESSAD
			? CompetenceSESSAD
			: this.isSAAD
			? CompetenceSAAD
			: CompetenceSSIAD;

		this.LABEL_INTERVENTION = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);

		if (this.missionRequest.nombreIntervenant === 1) {
			this.getDataIntervenantForSelectedMission();
		}
	}

	get LABEL_INTERVENANT() {
		return this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_INTERVENANT
		);
	}

	get LABEL_BENEFICIAIRE() {
		return this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_BENEFICIAIRE
		);
	}

	getEmployeeOfMission() {
		const employeeName = this.uniqueEmployeeOfMission
			? this.uniqueEmployeeOfMission.firstName +
			  ' ' +
			  this.uniqueEmployeeOfMission.lastName
			: 'Aucun';
		return employeeName;
	}

	getDataIntervenantForSelectedMission() {
		const isMissionWithOnlyOneEmployee =
			this.missionRequest.nombreIntervenant === 1;
		if (isMissionWithOnlyOneEmployee) {
			this.facade.employeeService
				.getEmployeeByMissionRequestId(this.missionRequest.id)
				.subscribe({
					next: (employee: Employee) => {
						if (employee) {
							this.uniqueEmployeeOfMission = employee;
						}
					},
					error: (err) => {
						this.logger.log(err);
					}
				});
		}
	}
}
